import axios from "axios";
import {API_URL} from "../config";

export const storeSaleService = async (values) => {
    return axios.post(`${API_URL}/sales`, {...values});
};
